const __getUserList = {
  method: "GET",
  url: "user/",
};

const __createSipExtension = (userId) => ({
  method: "POST",
  url: `user/${userId}/sip_extension`,
});

export { __getUserList, __createSipExtension };
